import { chartColours } from "../../themes/colours";
import { gis2QueryUrl } from "../../utils/urls.js"

import { planningLayerDefsBoundaries } from './planningLayerDefsBoundaries'
import { planningLayerDefsOpportunity } from './planningLayerDefsOpportunity'

const planningSiteAllocationsLayer = {
  layer: {
    id: "planning-site-allocations",
    type: "fill",
    paint: {
      "fill-color": chartColours.ldnDkPink,
      "fill-opacity": 0.7,
      "fill-outline-color": "#000000",
    },
    layout: {
      visibility: "none",
    },
  },
  source: {
    id: "planning-site-allocations",
    type: "geojson",
    data: gis2QueryUrl("planning_data_map_02", 102),
  },
  labels: {
    parent: "Site Allocations",
  },
  filters: {
    filterByChildren: false,
  },
  filterBySelectedRegion: true,
  category: "planning",
  popupAttributes: ["sitename"],
  info: {
    shortDescription:
      "A Site Allocation means that the site is allocation for a particular type of development or use.",
    longDescription:
      "A Site Allocation means that the site is allocation for a particular type of development or use, such as housing, employment and leisure, within a development plan. Allocated sites provide guidelines for planning decisions, help to diversify use of land and promote development at borough level.",
    longDescriptionTitle: "Site Allocations Layer Information",
  },
}

const shlaaLayer = {
  layer: {
    id: "shlaa",
    type: "fill",
    paint: {
      "fill-color": chartColours.ldnDkPink,
      "fill-opacity": 0.7,
      "fill-outline-color": "#000000",
    },
    layout: {
      visibility: "none",
    },
  },
  source: {
    id: "shlaa",
    type: "geojson",
    data: gis2QueryUrl("planning_data_map_02", 108),
  },
  labels: {
    parent: "Strategic Housing Land Availability Assessment (SHLAA)",
  },
  filters: {
    filterByChildren: false,
  },
  filterBySelectedRegion: true,
  category: "planning",
  popupAttributes: ["sitename", "status"],
  orderNumber: 4,
  info: {
    shortDescription:
      "A Strategic Housing Land Availability Assessment (SHLAA) is a technical exercise to determine the quantity and suitability of land potentially available for housing development.",
    longDescriptionTitle:
      "Strategic Housing Land Availability Assessment (SHLAA) Layer Information",
    longDescription: `A Strategic Housing Land Availability Assessment (SHLAA) is a technical exercise to determine the quantity and suitability of land potentially available for housing development.
    The SHLAA is not a site allocations exercise – the purpose of the SHLAA is to provide a robust indication of aggregate housing capacity at local authority level and across London. Only sites that are already approved or formally allocated for housing are identified on the web map.
    For more information, please visit: https://www.london.gov.uk/what-we-do/planning/london-plan/new-london-plan/strategic-housing-land-availability-assessment.`,
  },
}

const planningConservationLayer = {
  layer: {
    id: "planning-conservation",
    type: "fill",
    paint: {
      "fill-color": chartColours.ldnDkPink,
      "fill-opacity": 0.7,
      "fill-outline-color": "#000000",
    },
    layout: {
      visibility: "none",
    },
  },
  source: {
    id: "planning-conservation",
    type: "geojson",
    data: gis2QueryUrl("planning_data_map_02", 205),
  },
  labels: {
    parent: "Conservation Areas",
  },
  filters: {
    filterByChildren: false,
  },
  filterBySelectedRegion: true,
  category: "planning",
  popupAttributes: ["sitename"],
  info: {
    shortDescription:
      "Conservation Areas are areas where extra planning controls apply due to their special architectural and historic interest.",
    longDescriptionTitle: "Conservation Areas Layer Information",
    longDescription:
      "Conservation Areas are areas where extra planning controls apply due to their special architectural and historic interest.",
  },
}

const planningProtectedVistasLayer = {
  layer: {
    id: "planning-protected-vistas",
    beforeId: "planning-conservation",
    type: "fill",
    paint: {
      "fill-color": chartColours.ldnDkPink,
      "fill-opacity": 0.7,
      "fill-outline-color": "#000000",
    },
    layout: {
      visibility: "none",
    },
  },
  source: {
    id: "planning-protected-vistas",
    type: "geojson",
    data: gis2QueryUrl("planning_data_map_02", 213),
  },
  labels: {
    parent: "Protected Vistas",
  },
  filters: {
    filterByChildren: false,
  },
  filterBySelectedRegion: true,
  category: "planning",
  popupAttributes: ["sitename", "classification"],
  info: {
    shortDescription:
      "The Protected Vistas seek to protect the significant views which help to define London.",
    longDescriptionTitle: "Protected Vistas Layer Information",
    longDescription: `The Protected Vistas are established in the London Plan with more detailed guidance provided in the London View Management Framework (LVMF). The London Plan seeks to protect the significant views which help to define London, including the panoramas, linear views and townscape views in this layer.
    A planning application for a proposal that could affect one of these designated view should be accompanied by an analysis that explains, evaluates and justifies the visual impact on the view. Any planning application that is not consistent with the principles and guidance set out in the London Plan and the LVMF will be refused.`,
  },
}

export const planningLayersBase = {
  ...planningLayerDefsBoundaries,
}

export const planningLayersPoly = {
  ...planningLayerDefsOpportunity,
  "planning-site-allocations": planningSiteAllocationsLayer,
  "shlaa": shlaaLayer,
  "planning-conservation": planningConservationLayer,
  "planning-protected-vistas": planningProtectedVistasLayer,
}

export const planningLayersPoint = {
}